import React from "react";
import ReactDOM from "react-dom/client";
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";

import ErrorBoundary from "./components/ErrorBoundary";
import ThemedApp from "./components/ThemedApp";
import { captureError, initObservability, isExpectedAnswer } from "./lib/observability";
import { followUpAfterMutations } from "./lib/polling";
import { router } from "./routes";
import "./index.css";

void initObservability();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (!isExpectedAnswer(error, query.meta)) captureError(error, { source: "query" });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (!isExpectedAnswer(error, mutation.meta)) captureError(error, { source: "mutation" });
    },
  }),
});

// B6: a list is read again, a few times, after an action that changed it.
followUpAfterMutations(queryClient);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemedApp>
          <RouterProvider router={router} />
        </ThemedApp>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
